import React from 'react';
import { createPortal } from 'react-dom';
import { H3, Span } from '../Typography/Typography';

export type ConfirmProps = {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const Confirm: React.FC<ConfirmProps> = ({
  open,
  title = 'Confirm',
  message = 'Are you sure?',
  confirmText = 'Yes',
  cancelText = 'No',
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return createPortal(
    <div
      id={'confirm-dialogue'}
      className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999]"
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDown={e => {
        e.stopPropagation();
      }}
      onMouseUp={e => {
        e.stopPropagation();
      }}
    >
      <div className="bg-white rounded-lg p-6 min-w-[320px] shadow-lg text-black" onClick={e => e.stopPropagation()}>
        <H3 className="mt-0 mb-2 text-xl font-semibold">{title}</H3>
        <Span className="mb-4 block">{message}</Span>
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-100"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              onCancel();
            }}
          >
            {cancelText}
          </button>
          <button
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              onConfirm();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Confirm;
